function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("rect", {
  width: 24,
  height: 24
}), /*#__PURE__*/React.createElement("path", {
  fill: "#00141E",
  d: "M3.11111111,19 L20.8888889,19 C21.5,19 22,18.55 22,18 C22,17.45 21.5,17 20.8888889,17 L3.11111111,17 C2.5,17 2,17.45 2,18 C2,18.55 2.5,19 3.11111111,19 Z M3.04709326,13 L15.0028895,13 C15.5787908,13 16.0499828,12.55 16.0499828,12 C16.0499828,11.45 15.5787908,11 15.0028895,11 L3.04709326,11 C2.47119197,11 2,11.45 2,12 C2,12.55 2.47119197,13 3.04709326,13 Z M2,6 C2,6.55 2.5,7 3.11111111,7 L20.8888889,7 C21.5,7 22,6.55 22,6 C22,5.45 21.5,5 20.8888889,5 L3.11111111,5 C2.5,5 2,5.45 2,6 Z"
}));

var SvgHamburgerMenu = function SvgHamburgerMenu(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgHamburgerMenu, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/hamburgerMenu.c66f4f9a.svg";
export { ForwardRef as ReactComponent };